import { cn } from "@/lib/utils";
import { useOptionalQcIncidentModal } from "@/lib/qc/qcIncidentModalContext";

function incidentIdFromSegment(segment: string): number | null {
  const match = /^QC incident #(\d+)$/i.exec(segment.trim());
  if (match == null) {
    return null;
  }
  const incidentId = Number.parseInt(match[1], 10);
  return Number.isFinite(incidentId) && incidentId > 0 ? incidentId : null;
}

/** Renders plain text with "QC incident #123" segments opening a read-only incident modal. */
export function QcIncidentMessage({
  message,
  className,
}: {
  message: string;
  className?: string;
}): JSX.Element {
  const qcIncidentModal = useOptionalQcIncidentModal();
  const parts = message.split(/(QC incident #\d+)/gi);

  return (
    <span className={cn(className)}>
      {parts.map((part, index) => {
        const incidentId = incidentIdFromSegment(part);
        if (incidentId != null) {
          if (qcIncidentModal != null) {
            return (
              <button
                key={`qc-incident-link-${index}`}
                type="button"
                className="font-semibold underline underline-offset-2 hover:text-inherit"
                onClick={() => qcIncidentModal.openQcIncident(incidentId, "view")}
              >
                {part}
              </button>
            );
          }
          return (
            <span key={`qc-incident-link-${index}`} className="font-semibold">
              {part}
            </span>
          );
        }
        return <span key={`qc-incident-text-${index}`}>{part}</span>;
      })}
    </span>
  );
}
